
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","viewBox":"0 0 45 45","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M38.81 37.249a.948.948 0 010-1.895.949.949 0 010 1.895zm-8.026-18.808v4.698h-9.947v-4.698a4.98 4.98 0 014.974-4.973 4.979 4.979 0 014.973 4.973zm-9.947 20.266h9.946v-3.286h-9.946v3.286zm0-5.286h9.946v-8.282h-9.946v8.282zm-5.89-14.98v4.698H5v-4.698a4.98 4.98 0 014.974-4.973 4.979 4.979 0 014.973 4.973zM5 38.707h9.946v-3.286H5v3.286zm0-5.286h9.946v-8.282H5v8.282zM9.974 8.967a.956.956 0 11-.003 1.913.956.956 0 01.003-1.913zm15.837 0a.956.956 0 11-.003 1.913.956.956 0 01.003-1.913zM39.81 33.541V11.468H28.319c.278-.451.447-.977.447-1.545a2.95 2.95 0 00-1.955-2.77L26.81 6h1.644a1 1 0 000-2h-5.287a1 1 0 100 2h1.643l.001 1.153a2.952 2.952 0 00-1.956 2.77c0 .568.169 1.094.447 1.545h-10.82c.278-.451.447-.977.447-1.545a2.951 2.951 0 00-1.955-2.77V6h1.643a1 1 0 000-2H7.331a1 1 0 100 2h1.643v1.153a2.951 2.951 0 00-1.956 2.77c0 .735.279 1.4.725 1.917C4.99 12.773 3 15.377 3 18.441v22.266h13.947V18.441a6.95 6.95 0 00-2.094-4.973h6.078a6.95 6.95 0 00-2.094 4.973v22.266h13.947V18.441a6.95 6.95 0 00-2.094-4.973h7.12v20.073a2.943 2.943 0 00-1.947 2.761 2.95 2.95 0 002.947 2.947 2.95 2.95 0 002.947-2.947 2.943 2.943 0 00-1.947-2.761z","fill-rule":"evenodd"}})])
          )
        }
      }
    